import * as actionTypes from "./flowValidatorActionTypes";
import { getActionProvider } from "../../../../Application/actions/actionsBuilder";

export const toggleErrorMessagesBar = getActionProvider<{ showErrorMessagesBar: boolean }>(
  actionTypes.showErrorMessagesBar,
);
export const removeFixedError = getActionProvider<{ id: string }>(actionTypes.removeFixedError);
